module.exports = __webpack_public_path__ + "assets/img/tit2.b4cbe895.png";